import type { CategoryNode } from '../types'

export function categoryHasActiveArticle(category: CategoryNode, activePath: string | undefined): boolean {
  if (!activePath) return false

  if (category.articles.some((article) => article.path === activePath)) {
    return true
  }

  return category.children.some((child) => categoryHasActiveArticle(child, activePath))
}

export function findExpandedCategoriesForArticle(
  categoryTree: CategoryNode[],
  activePath: string | undefined,
  basePath: string
): string[] {
  if (!activePath) return []

  const expandedPaths: string[] = []

  function findPath(categories: CategoryNode[]): boolean {
    for (const category of categories) {
      if (category.articles.some((article) => article.path === activePath)) {
        expandedPaths.push(`${basePath}-${category.path}`)
        return true
      }

      if (findPath(category.children)) {
        expandedPaths.push(`${basePath}-${category.path}`)
        return true
      }
    }
    return false
  }

  findPath(categoryTree)
  return expandedPaths
}
